// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2DNLe","disclaimer":"styles_disclaimer__40iq-"};